import { Component, HostListener, Inject, LOCALE_ID, OnChanges, OnInit } from '@angular/core';
import moment from 'moment';
// @ts-ignore
import * as localization_en_au from 'moment/locale/en-au';
// @ts-ignore
// @ts-ignore
// @ts-ignore
import * as localization_fr from 'moment/locale/fr';
// @ts-ignore
import * as localization_es_us from 'moment/locale/es-us';
import { PermissionsService } from './services/permissions/permissions.service';
import { AuthService } from './services/auth/auth.service';
import { ConstantsService } from './services/constants/constants.service';
import * as Cookies from 'js-cookie';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { esUsLocale, frLocale } from 'ngx-bootstrap/locale';
import { Router, Event, NavigationEnd } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
// BookDemoModal temporarily disabled — may be re-added later.
// import { BookDemoModalComponent } from './components/book-demo-modal/book-demo-modal.component';
import { OnboardingTutorialModalComponent } from './components/onboarding-tutorial-modal/onboarding-tutorial-modal.component';
import { PlanService } from './services/plan-status/plan-status.service';
import * as _ from 'lodash';
import { environment } from '../environments/environment';
import { filter, of, catchError } from 'rxjs';
import { IdService } from './services/id/id.service';
export interface planDetails {
  userRole: string;
  planType: string;
  showBanner: boolean;
  planActive: boolean;
  validFrom: string;
  validTill: string;
  paymentStatus: string;
  isNonCbTrial: boolean;
  trialDaysRemaining: number;
  trialEndDate: string;
  remainingProfileCredits: number;
  isLowProfiles: boolean;
  showExpiry: boolean;
  expiryDate: string;
}

const LOW_PROFILES_RATIO = 0.1;
const EXPIRING_SOON_DAYS = 30;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.pug',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  title = 'app-xref-com';
  org_uid = Cookies.get(ConstantsService.ORG_COOKIE);
  planStatus: planDetails = {
    userRole: ' ',
    planType: ' ',
    showBanner: false,
    planActive: false,
    validFrom: ' ',
    validTill: ' ',
    paymentStatus: ' ',
    isNonCbTrial: false,
    trialDaysRemaining: 0,
    trialEndDate: '',
    remainingProfileCredits: 0,
    isLowProfiles: false,
    showExpiry: false,
    expiryDate: '',
  };
  showNav = true;
  fullPageRoute = false;
  currentUrl: string = '';
  signUpImprovementsFF = false;
  billingFlow = false;
  responsiveScreen = 0;
  ENT_10781_SIGNUP_IMPROVEMENTS = false;
  private bookDemoModalShown = false;

  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private permissions: PermissionsService,
    private auth: AuthService,
    private id: IdService,
    private planservice: PlanService,
    private localeService: BsLocaleService,
    private router: Router,
    private modalService: BsModalService,
  ) {
    if (locale === 'EN-AU') {
      moment.updateLocale('en-au', localization_en_au);
    } else if (locale === 'FR-CA') {
      moment.updateLocale('fr', localization_fr);
      defineLocale('fr', frLocale);
      this.localeService.use('fr');
    } else if (locale === 'ES-US') {
      moment.updateLocale('es-us', localization_es_us);
      defineLocale('es-us', esUsLocale);
      this.localeService.use('es-us');
    } else {
      moment.locale('en');
    }
  }
  @HostListener('window:scroll', []) onWindowScroll(e) {
    if (window.innerHeight + (window.scrollY + 1) >= document.body.offsetHeight) {
      let button = document.getElementById('xrefButton');
      button?.setAttribute('style', 'bottom:100px');
    } else if (window.innerHeight + window.scrollY < document.body.offsetHeight - 100 || window.scrollY == 0) {
      let button = document.getElementById('xrefButton');
      button?.setAttribute('style', 'bottom:24px');
    }
  }
  ngOnInit() {
    this.ENT_10781_SIGNUP_IMPROVEMENTS = this.permissions.isFeatureActivated('ent-10781-signup-improvements');
    this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe({
      next: (event) => {
        this.responsiveScreen = document.documentElement.clientWidth;
        window.addEventListener('resize', () => this.responsiveScreen);
        if (this.ENT_10781_SIGNUP_IMPROVEMENTS) {
          this.billingFlow = event.url === '/plan-comparison' && this.permissions.redirectToPlanComparison;
        } else {
          this.billingFlow = event.url === '/billing';
        }
        this.fullPageRoute = event.url === '/request' || event.url.startsWith('/request?');
        if (this.currentUrl != '') {
          if (
            (this.currentUrl.includes('people/profile/') && event.url.includes('reference-report/')) ||
            (this.currentUrl.includes('people/profile/') && event.url.includes('/report/')) ||
            (this.currentUrl.includes('people/profile/') && event.url.includes('/insights'))
          ) {
            let previousUrl = localStorage.getItem('previousUrl');
            if (previousUrl) {
              localStorage.setItem('previousUrlMain', previousUrl);
            }
          }
          if (
            (this.currentUrl.includes('reference-report/') && event.url.includes('people/profile/')) ||
            (this.currentUrl.includes('/report/') && event.url.includes('people/profile/')) ||
            (this.currentUrl.includes('/insights') && event.url.includes('people/profile/'))
          ) {
            let previousUrlMain = localStorage.getItem('previousUrlMain');
            if (previousUrlMain) {
              localStorage.setItem('previousUrl', previousUrlMain);
            } else {
              localStorage.setItem('previousUrl', '/requests');
            }
          } else {
            localStorage.setItem('previousUrl', this.currentUrl);
          }
        }
        this.currentUrl = event.url;

        if (!this.bookDemoModalShown) {
          this.bookDemoModalShown = true;
          const isMobile = window.innerWidth < 768;

          // BookDemoModal ("Would you like to schedule a demo with us?") is
          // temporarily disabled and may be re-added later. The
          // OnboardingTutorialModal (video screen) flow is preserved below.
          //
          // if (!BookDemoModalComponent.wasDismissed()) {
          //   if (isMobile) {
          //     BookDemoModalComponent.markAsDismissed();
          //     OnboardingTutorialModalComponent.markAsDismissed();
          //   } else {
          //     const bookDemoRef = this.modalService.show(BookDemoModalComponent, {
          //       class: 'm-popup book-demo-modal',
          //     });
          //     bookDemoRef.onHidden?.subscribe(() => {
          //       if (!OnboardingTutorialModalComponent.wasDismissed()) {
          //         this.modalService.show(OnboardingTutorialModalComponent, {
          //           class: 'modal-tutorial',
          //         });
          //       }
          //     });
          //   }
          // } else if (!OnboardingTutorialModalComponent.wasDismissed()) {
          if (!OnboardingTutorialModalComponent.wasDismissed()) {
            if (isMobile) {
              OnboardingTutorialModalComponent.markAsDismissed();
            } else {
              this.modalService.show(OnboardingTutorialModalComponent, {
                class: 'modal-tutorial',
              });
            }
          }
          // }
        }
      },
    });
    let token;
    if (this.permissions.isGlobalFeatureActivated('ENT-9105-PENETRATION-TEST-2025')) {
      token = this.id.getAuthToken();
    } else {
      token = environment.use_global_id
        ? Cookies.get(ConstantsService.AUTH_TOKEN)
        : Cookies.get(ConstantsService.DEPRECATED_AUTH_TOKEN);
    }

    if (token !== undefined) {
      this.auth.getUserUid();
    }
    this.setNavCheck();
  }
  setNavCheck(): void {
    this.permissions.getNavCheck().subscribe((data: boolean) => {
      this.showNav = data;
    });
  }
  async changeOfRoutes() {
    await this.planservice
      .getPlan('sum')
      .toPromise()
      .then((res) => {
        this.planStatus.isLowProfiles = false;
        this.planStatus.showExpiry = false;
        this.planStatus.expiryDate = '';
        if (res.message != 'No plans found') {
          if (this.ENT_10781_SIGNUP_IMPROVEMENTS) {
            this.planStatus.isNonCbTrial = !!res.data.object.is_non_cb_trial;
            this.planStatus.trialDaysRemaining = Math.max(
              0,
              moment.utc(res.data.object.valid_to).diff(moment.utc(), 'days'),
            );
            this.planStatus.trialEndDate = moment
              .utc(res.data.object.valid_to)
              .local()
              .subtract(1, 'second')
              .format('ll');
            this.planStatus.remainingProfileCredits = res.data.object.remaining_profile_credits ?? 0;
          }

          const valid_start_time = moment.utc(res.data.object.valid_from).format('YYYY-MM-DD HH:mm:ss');
          const current_time = moment.utc(new Date()).format('YYYY-MM-DD HH:mm:ss');
          const valid_end_time = moment.utc(res.data.object.valid_to).format('YYYY-MM-DD HH:mm:ss');
          const local_valid_start_time = moment.utc(valid_start_time).local().format('ll');
          const local_valid_end_time = moment.utc(valid_end_time).local().format('ll');

          if (valid_start_time > current_time && valid_end_time > current_time) {
            this.planStatus.planType = 'future plan';
            this.planStatus.showBanner = true;
            this.planStatus.userRole = this.permissions.userRolePlan;
            this.planStatus.planActive = res.data.object.active;
            this.planStatus.validFrom = local_valid_start_time;
            this.planStatus.validTill = local_valid_end_time;
            this.planStatus.paymentStatus = res.data.object.payment_status;
            this.planStatus = _.cloneDeep(this.planStatus);
            this.planservice.setPlan({
              type: this.planStatus.planType,
              role: this.planStatus.userRole,
              valid_start_time: valid_start_time,
              current_time: current_time,
              valid_end_time: valid_end_time,
              message: res.message,
              active: res.data.object.active,
              payment_status: res.data.object.payment_status,
              is_non_cb_trial: this.planStatus.isNonCbTrial,
              remaining_profile_credits: this.planStatus.remainingProfileCredits,
            });
            this.planservice.setGuard(false);
          } else if (valid_end_time < current_time) {
            const plan_type = res?.data?.object?.plan_type;
            this.planStatus.planType =
              plan_type == ConstantsService.CB_PLAN_SIGN_UP ? 'past_sign_up_plan' : 'past_sales_assisted_plan';
            this.planStatus.showBanner = true;
            this.planStatus.userRole = this.permissions.userRolePlan;
            this.planStatus.planActive = res.data.object.active;
            this.planStatus.validFrom = local_valid_start_time;
            this.planStatus.validTill = local_valid_end_time;
            this.planStatus.paymentStatus = res.data.object.payment_status;
            this.planStatus = _.cloneDeep(this.planStatus);
            this.planservice.setPlan({
              type: this.planStatus.planType,
              role: this.planStatus.userRole,
              valid_start_time: valid_start_time,
              current_time: current_time,
              valid_end_time: valid_end_time,
              message: res.message,
              active: res.data.object.active,
              payment_status: res.data.object.payment_status,
              is_non_cb_trial: this.planStatus.isNonCbTrial,
              remaining_profile_credits: this.planStatus.remainingProfileCredits,
            });
            this.planservice.setGuard(false);
          } else if (valid_start_time < current_time && valid_end_time > current_time) {
            this.planStatus.planType = 'current plan';
            this.planStatus.showBanner = false;
            this.planStatus.userRole = this.permissions.userRolePlan;
            this.planStatus.planActive = res.data.object.active;
            this.planStatus.validFrom = local_valid_start_time;
            this.planStatus.validTill = local_valid_end_time;
            this.planStatus.paymentStatus = res.data.object.payment_status;
            this.planStatus = _.cloneDeep(this.planStatus);
            this.planservice.setPlan({
              type: this.planStatus.planType,
              role: this.planStatus.userRole,
              valid_start_time: valid_start_time,
              current_time: current_time,
              valid_end_time: valid_end_time,
              message: res.message,
              active: res.data.object.active,
              payment_status: res.data.object.payment_status,
              is_non_cb_trial: this.planStatus.isNonCbTrial,
              remaining_profile_credits: this.planStatus.remainingProfileCredits,
            });
            this.planservice.setGuard(res.data.object.active === true ? true : false);
            this.updateSubscriptionBanners(res.data.object);
          }
        } else {
          this.planStatus.planType = 'no plan';
          this.planStatus.showBanner = true;
          this.planStatus.userRole = this.permissions.userRolePlan;
          this.planStatus.planActive = false;
          this.planStatus.validFrom = ' ';
          this.planStatus.validTill = ' ';
          this.planStatus.paymentStatus = res.data.object.payment_status;
          this.planStatus = _.cloneDeep(this.planStatus);
          this.planservice.setPlan({
            type: this.planStatus.planType,
            role: this.planStatus.userRole,
            valid_start_time: ' ',
            current_time: ' ',
            valid_end_time: ' ',
            message: res.message,
            active: res.data.object.active,
            payment_status: res.data.object.payment_status,
            is_non_cb_trial: this.planStatus.isNonCbTrial,
            remaining_profile_credits: this.planStatus.remainingProfileCredits,
          });
          this.planservice.setGuard(false);
        }
      })
      .catch((error) => {});
  }

  // Low-profile / expiring-soon banners. Uses the same whole-day UTC count as the trial banner.
  // Renewal status is only fetched when the plan ends within EXPIRING_SOON_DAYS, and is never awaited.
  updateSubscriptionBanners(plan): void {
    if (plan.active !== true || plan.payment_status !== 1 || plan.is_non_cb_trial) {
      return;
    }
    const totalProfiles = plan.total_plans_sum ?? 0;
    const remainingProfiles = plan.filtered_plans_sum ?? 0;
    const isLowProfiles = totalProfiles > 0 && remainingProfiles < LOW_PROFILES_RATIO * totalProfiles;

    const endDate = plan.furthest_valid_date;
    const isExpiring = !!endDate && moment.utc(endDate).diff(moment.utc(), 'days') < EXPIRING_SOON_DAYS;
    if (!isExpiring) {
      this.applySubscriptionBanners(isLowProfiles, false, '');
      return;
    }

    const expiryDate = moment.utc(endDate).local().subtract(1, 'second').format('ll');
    this.planservice
      .getRenewalStatus()
      .pipe(catchError(() => of(null)))
      .subscribe((res) => {
        if (this.planStatus.planType !== 'current plan') {
          return;
        }
        const renewal = res?.data;
        const showExpiry = renewal?.has_future_plan !== true && renewal?.is_auto_renewing === false;
        this.applySubscriptionBanners(isLowProfiles, showExpiry, expiryDate);
      });
  }

  private applySubscriptionBanners(isLowProfiles: boolean, showExpiry: boolean, expiryDate: string): void {
    this.planStatus.isLowProfiles = isLowProfiles;
    this.planStatus.showExpiry = showExpiry;
    this.planStatus.expiryDate = expiryDate;
    this.planStatus.showBanner = isLowProfiles || showExpiry;
    this.planStatus = _.cloneDeep(this.planStatus);
  }
}
